import { Link } from 'react-router-dom';

export function UiLinkButton({
  to,
  variant = 'link',
  size = 'md',
  className = '',
  children,
  ...rest
}) {
  if (to) {
    return (
      <Link
        to={to}
        className={`ui-link-btn ui-link-btn--${variant} ui-link-btn--${size} ${className}`.trim()}
        {...rest}
      >
        {children}
      </Link>
    );
  }
  return (
    <button
      type="button"
      className={`ui-link-btn ui-link-btn--${variant} ui-link-btn--${size} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
